
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(
    'section',
    { staticClass: 'home' },
    [
      _c('main-nav', { ref: 'mainNav' }),
      _c(
        'div',
        { staticClass: 'su-body' },
        [
          _c(
            'div',
            {
              directives: [
                {
                  name: 'waypoint',
                  rawName: 'v-waypoint',
                  value: {
                    active: true,
                    callback: _vm.onWaypoint1,
                    options: _vm.intersectionOptions,
                  },
                  expression:
                    '{ active: true, callback: onWaypoint1, options: intersectionOptions }',
                },
              ],
              staticClass: 'su-slide su-section-one',
            },
            [
              _vm.display === 'xs'
                ? _c('vimeo-player', {
                    ref: 'player',
                    staticClass: 'video-player player-hero',
                    attrs: {
                      options: {
                        responsive: true,
                        muted: true,
                        controls: false,
                      },
                      'video-id': '1017124952',
                    },
                    on: { ready: _vm.onReady },
                  })
                : _c('vimeo-player', {
                    ref: 'player',
                    staticClass: 'video-player player-hero',
                    attrs: {
                      options: {
                        responsive: true,
                        muted: true,
                        controls: false,
                      },
                      'video-id': '1017124952',
                    },
                    on: { ready: _vm.onReady },
                  }),
              _c('div', { staticClass: 'video-player-button' }, [
                _c(
                  'label',
                  {
                    staticClass: 'unmuted toggle-sound',
                    class: { sound_mute: _vm.mute },
                    attrs: { for: 'volumeToggle1' },
                  },
                  [_vm._m(0)],
                ),
                _c('input', {
                  directives: [
                    {
                      name: 'model',
                      rawName: 'v-model',
                      value: _vm.$data.mute,
                      expression: '$data.mute',
                    },
                  ],
                  attrs: { id: 'volumeToggle1', type: 'checkbox' },
                  domProps: {
                    checked: Array.isArray(_vm.$data.mute)
                      ? _vm._i(_vm.$data.mute, null) > -1
                      : _vm.$data.mute,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.muteToggle();
                    },
                    change: function ($event) {
                      var $$a = _vm.$data.mute,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false;
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v);
                        if ($$el.checked) {
                          $$i < 0 && _vm.$set(_vm.$data, 'mute', $$a.concat([$$v]));
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.$data,
                              'mute',
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1)),
                            );
                        }
                      } else {
                        _vm.$set(_vm.$data, 'mute', $$c);
                      }
                    },
                  },
                }),
              ]),
            ],
            1,
          ),
          _c(
            'div',
            {
              staticClass: 'm-0 p-0',
              attrs: { id: 'about-us' },
              on: {
                mouseover: function ($event) {
                  return _vm.$refs.mainNav.setFocus(1);
                },
                mouseleave: function ($event) {
                  return _vm.$refs.mainNav.setNotFocus(1);
                },
              },
            },
            [
              _vm._m(1),
              _c('div', { staticClass: 'su-section-three' }, [
                _c('div', { staticClass: 'w-100' }, [
                  _c(
                    'div',
                    {
                      staticClass: 'w-auto',
                      on: {
                        mouseover: function ($event) {
                          return _vm.lockMarquee1(true);
                        },
                        mouseleave: function ($event) {
                          return _vm.lockMarquee1(false);
                        },
                      },
                    },
                    [
                      _c(
                        'vue-marquee-slider',
                        {
                          staticClass: 'marquee-slider',
                          staticStyle: { 'margin-bottom': 'calc(-4rem - 50px)' },
                          attrs: {
                            id: 'marquee-slider-1',
                            space: 50,
                            speed: 100000,
                            width: 400,
                            paused: _vm.$data.marquee1Pause,
                            reverse: '',
                          },
                        },
                        [
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-1' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-5' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-6' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-7' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-8' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-10' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-13' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-15' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-17' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-20' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-22' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-23' },
                          }),
                        ],
                      ),
                    ],
                    1,
                  ),
                ]),
                _c('div', { staticClass: 'w-100' }, [
                  _c(
                    'div',
                    {
                      staticClass: 'w-auto',
                      on: {
                        mouseover: function ($event) {
                          return _vm.lockMarquee2(true);
                        },
                        mouseleave: function ($event) {
                          return _vm.lockMarquee2(false);
                        },
                      },
                    },
                    [
                      _c(
                        'vue-marquee-slider',
                        {
                          staticClass: 'marquee-slider',
                          attrs: {
                            id: 'marquee-slider-2',
                            space: 50,
                            speed: 100000,
                            width: 400,
                            paused: _vm.$data.marquee2Pause,
                          },
                        },
                        [
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-2' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-3' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-4' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-9' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-11' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-12' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-14' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-16' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-18' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-19' },
                          }),
                          _c('div', {
                            staticClass: 'marquee-image',
                            attrs: { id: 'marquee-image-21' },
                          }),
                        ],
                      ),
                    ],
                    1,
                  ),
                ]),
              ]),
            ],
          ),
          _c(
            'div',
            {
              staticClass: 'su-section-four container',
              attrs: { id: 'know-how' },
              on: {
                mouseover: function ($event) {
                  return _vm.$refs.mainNav.setFocus(2);
                },
                mouseleave: function ($event) {
                  return _vm.$refs.mainNav.setNotFocus(2);
                },
              },
            },
            [
              _c('div', { staticClass: 'row' }, [
                _c('div', { staticClass: 'col-1 void-column' }),
                _c('div', { staticClass: 'col-12 col-md-11' }, [
                  _c('h1', [_vm._v('Our know-how has been built over three decades')]),
                  _vm._m(2),
                  _c(
                    'div',
                    [
                      _c('b-collapse', { attrs: { id: 'collapse-knowhow' } }, [
                        _c('h3', [
                          _vm._v(' We have the personnel, skills and'),
                          _c('br'),
                          _vm._v(' capacity to create customized'),
                          _c('br'),
                          _vm._v(' entertainment for'),
                          _c('br'),
                          _vm._v(' a wide variety of needs and'),
                          _c('br'),
                          _vm._v(' venues in the tourism industry'),
                          _c('br'),
                          _vm._v(' and beyond. '),
                        ]),
                        _c('h3', [
                          _vm._v(' From cruise ships and theme'),
                          _c('br'),
                          _vm._v(' parks to hotels and resorts, from'),
                          _c('br'),
                          _vm._v(' adverts and TV shows to'),
                          _c('br'),
                          _vm._v(' concerts, tours, and corporate'),
                          _c('br'),
                          _vm._v(' events, all the world’s our stage. '),
                        ]),
                      ]),
                      _c(
                        'b-button',
                        {
                          directives: [
                            {
                              name: 'b-toggle',
                              rawName: 'v-b-toggle.collapse-knowhow',
                              modifiers: { 'collapse-knowhow': true },
                            },
                          ],
                          on: {
                            click: function ($event) {
                              _vm.collapseButtonKnowhowStatus =
                                (_vm.collapseButtonKnowhowStatus + 1) % 2;
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.toggleButtonText[_vm.collapseButtonKnowhowStatus]))],
                      ),
                    ],
                    1,
                  ),
                ]),
              ]),
            ],
          ),
          _c(
            'div',
            {
              staticClass: 'su-section-five container',
              attrs: { id: 'services' },
              on: {
                mouseover: function ($event) {
                  return _vm.$refs.mainNav.setFocus(3);
                },
                mouseleave: function ($event) {
                  return _vm.$refs.mainNav.setNotFocus(3);
                },
              },
            },
            [
              _c(
                'div',
                {
                  directives: [
                    {
                      name: 'waypoint',
                      rawName: 'v-waypoint',
                      value: {
                        active: true,
                        callback: _vm.onWaypoint2,
                        options: _vm.intersectionOptions,
                      },
                      expression:
                        '{ active: true, callback: onWaypoint2, options: intersectionOptions }',
                    },
                  ],
                  staticClass: 'row',
                },
                [
                  _c('div', { staticClass: 'col-1 void-column' }),
                  _c('div', { staticClass: 'col-12 col-md-11 wide-card' }, [
                    _c('div', { staticClass: 'row' }, [
                      _c('div', { staticClass: 'col-12' }, [
                        _c(
                          'div',
                          { staticClass: 'player-container pt-3' },
                          [
                            _c('vimeo-player', {
                              ref: 'player2',
                              staticClass: 'video-player',
                              attrs: {
                                'video-id': '837595132',
                                options: {
                                  portrait: false,
                                  byline: false,
                                  title: false,
                                  muted: true,
                                  loop: true,
                                  controls: false,
                                },
                              },
                            }),
                            _c('div', { staticClass: 'video-player-button' }, [
                              _c(
                                'label',
                                {
                                  staticClass: 'unmuted toggle-sound',
                                  class: { sound_mute: _vm.mute2 },
                                  attrs: { for: 'volumeToggle2' },
                                },
                                [_vm._m(3)],
                              ),
                              _c('input', {
                                directives: [
                                  {
                                    name: 'model',
                                    rawName: 'v-model',
                                    value: _vm.$data.mute2,
                                    expression: '$data.mute2',
                                  },
                                ],
                                attrs: { id: 'volumeToggle2', type: 'checkbox' },
                                domProps: {
                                  checked: Array.isArray(_vm.$data.mute2)
                                    ? _vm._i(_vm.$data.mute2, null) > -1
                                    : _vm.$data.mute2,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.muteToggle2();
                                  },
                                  change: function ($event) {
                                    var $$a = _vm.$data.mute2,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false;
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v);
                                      if ($$el.checked) {
                                        $$i < 0 && _vm.$set(_vm.$data, 'mute2', $$a.concat([$$v]));
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.$data,
                                            'mute2',
                                            $$a.slice(0, $$i).concat($$a.slice($$i + 1)),
                                          );
                                      }
                                    } else {
                                      _vm.$set(_vm.$data, 'mute2', $$c);
                                    }
                                  },
                                },
                              }),
                            ]),
                          ],
                          1,
                        ),
                      ]),
                      _vm._m(4),
                      _c(
                        'div',
                        { staticClass: 'col-12 mt-md-5' },
                        [
                          _c('b-collapse', { attrs: { id: 'collapse-entertainment' } }, [
                            _c('h3', [
                              _vm._v(' First up, we create shows, videos'),
                              _c('br'),
                              _vm._v(' and more from start to finish. '),
                            ]),
                            _c('h3', [
                              _vm._v(' So we draft concepts,'),
                              _c('br'),
                              _vm._v(' storyboards and scripts.'),
                              _c('br'),
                              _vm._v(' We design and produce sets and'),
                              _c('br'),
                              _vm._v(' costumes.'),
                              _c('br'),
                              _vm._v(' We handle sound and lighting.'),
                              _c('br'),
                              _vm._v(' And we provide artistic direction,'),
                              _c('br'),
                              _vm._v(' musical arrangements and'),
                              _c('br'),
                              _vm._v(' choreography. '),
                            ]),
                            _c('h3', [
                              _vm._v(" But that's not all. We also recruit"),
                              _c('br'),
                              _vm._v(' and manage artists, technicians'),
                              _c('br'),
                              _vm._v(' and other entertainment professionals.'),
                              _c('br'),
                              _vm._v(" So if you're looking"),
                              _c('br'),
                              _vm._v(' for a cast, a writing team,'),
                              _c('br'),
                              _vm._v(' a backstage crew, or an entire production,'),
                              _c('br'),
                              _vm._v(' look no further. '),
                            ]),
                          ]),
                          _c(
                            'b-button',
                            {
                              directives: [
                                {
                                  name: 'b-toggle',
                                  rawName: 'v-b-toggle.collapse-entertainment',
                                  modifiers: { 'collapse-entertainment': true },
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  _vm.collapseButtonEntertainmentStatus =
                                    (_vm.collapseButtonEntertainmentStatus + 1) % 2;
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.toggleButtonText[_vm.collapseButtonEntertainmentStatus]),
                              ),
                            ],
                          ),
                        ],
                        1,
                      ),
                    ]),
                  ]),
                ],
              ),
            ],
          ),
          _c(
            'div',
            {
              staticClass: 'su-section-six container',
              attrs: { id: 'shows' },
              on: {
                mouseover: function ($event) {
                  return _vm.$refs.mainNav.setFocus(4);
                },
                mouseleave: function ($event) {
                  return _vm.$refs.mainNav.setNotFocus(4);
                },
              },
            },
            [_vm._m(5)],
          ),
          _c(
            'div',
            {
              staticClass: 'su-section-seven container',
              attrs: { id: 'contact-us' },
              on: {
                mouseover: function ($event) {
                  return _vm.$refs.mainNav.setFocus(5);
                },
                mouseleave: function ($event) {
                  return _vm.$refs.mainNav.setNotFocus(5);
                },
              },
            },
            [
              _c('div', { staticClass: 'row' }, [
                _c('div', { staticClass: 'col-1 void-column' }),
                _c('div', { staticClass: 'col-12 col-md-11' }, [
                  _c('div', { staticClass: 'row' }, [
                    _vm._m(6),
                    _c(
                      'form',
                      {
                        staticClass: 'col-lg-8 col-12',
                        on: {
                          submit: function ($event) {
                            $event.preventDefault();
                            return _vm.submitEntry.apply(null, arguments);
                          },
                        },
                      },
                      [
                        _c('div', { staticClass: 'row' }, [
                          _c('div', { staticClass: 'col-md-6 col-12' }, [
                            _c('div', { staticClass: 'form-group' }, [
                              _c('label', { attrs: { for: 'name' } }, [_vm._v('Complete name*')]),
                              _c('input', {
                                directives: [
                                  {
                                    name: 'model',
                                    rawName: 'v-model',
                                    value: _vm.form.name,
                                    expression: 'form.name',
                                  },
                                ],
                                staticClass: 'form-control',
                                class: { 'su-error-field': _vm.msg.name.length },
                                attrs: {
                                  id: 'name',
                                  name: 'name',
                                  placeholder: 'Enter name here...',
                                  type: 'text',
                                  disabled: _vm.loadingFormRequest,
                                },
                                domProps: { value: _vm.form.name },
                                on: {
                                  change: function ($event) {
                                    _vm.msg.name = '';
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return;
                                    _vm.$set(_vm.form, 'name', $event.target.value);
                                  },
                                },
                              }),
                              _vm.msg.name.length
                                ? _c('span', { staticClass: 'su-error-field-text' }, [
                                    _vm._v(_vm._s(_vm.msg.name)),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _c('div', { staticClass: 'col-md-6 col-12' }, [
                            _c('div', { staticClass: 'form-group' }, [
                              _c('label', { attrs: { for: 'email' } }, [_vm._v('Email*')]),
                              _c('input', {
                                directives: [
                                  {
                                    name: 'model',
                                    rawName: 'v-model',
                                    value: _vm.form.email,
                                    expression: 'form.email',
                                  },
                                ],
                                staticClass: 'form-control',
                                class: { 'su-error-field': _vm.msg.email.length },
                                attrs: {
                                  id: 'email',
                                  name: 'email',
                                  placeholder: 'Enter email here',
                                  type: 'text',
                                  disabled: _vm.loadingFormRequest,
                                },
                                domProps: { value: _vm.form.email },
                                on: {
                                  change: function ($event) {
                                    _vm.msg.email = '';
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return;
                                    _vm.$set(_vm.form, 'email', $event.target.value);
                                  },
                                },
                              }),
                              _vm.msg.email.length
                                ? _c('span', { staticClass: 'su-error-field-text' }, [
                                    _vm._v(_vm._s(_vm.msg.email)),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _c('div', { staticClass: 'col-12' }, [
                            _c('div', { staticClass: 'form-group' }, [
                              _c('label', { attrs: { for: 'message' } }, [_vm._v('Request*')]),
                              _c('textarea', {
                                directives: [
                                  {
                                    name: 'model',
                                    rawName: 'v-model',
                                    value: _vm.form.message,
                                    expression: 'form.message',
                                  },
                                ],
                                class: { 'su-error-field': _vm.msg.message.length },
                                attrs: {
                                  name: 'message',
                                  id: 'message',
                                  placeholder: 'Enter your request here...',
                                  disabled: _vm.loadingFormRequest,
                                },
                                domProps: { value: _vm.form.message },
                                on: {
                                  change: function ($event) {
                                    _vm.msg.message = '';
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return;
                                    _vm.$set(_vm.form, 'message', $event.target.value);
                                  },
                                },
                              }),
                              _vm.msg.message.length
                                ? _c('span', { staticClass: 'su-error-field-text' }, [
                                    _vm._v(_vm._s(_vm.msg.message)),
                                  ])
                                : _vm._e(),
                              _c('span', { staticClass: 'su-info-field-text' }, [
                                _vm._v('Characters: ' + _vm._s(_vm.form.message.length)),
                              ]),
                            ]),
                          ]),
                          _c('div', { staticClass: 'col-md-6 col-12 d-flex align-items-center' }, [
                            _c('div', { staticClass: 'form-group' }, [
                              _c(
                                'div',
                                {
                                  staticClass:
                                    'custom-control custom-checkbox custom-control-inline',
                                },
                                [
                                  _c('input', {
                                    directives: [
                                      {
                                        name: 'model',
                                        rawName: 'v-model',
                                        value: _vm.form.privacy,
                                        expression: 'form.privacy',
                                      },
                                    ],
                                    staticClass: 'custom-control-input',
                                    class: { 'su-error-field': _vm.msg.privacy.length },
                                    attrs: {
                                      name: 'terms',
                                      id: 'terms',
                                      type: 'checkbox',
                                      value: 'terms',
                                      disabled: _vm.loadingFormRequest,
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.form.privacy)
                                        ? _vm._i(_vm.form.privacy, 'terms') > -1
                                        : _vm.form.privacy,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = _vm.form.privacy,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false;
                                          if (Array.isArray($$a)) {
                                            var $$v = 'terms',
                                              $$i = _vm._i($$a, $$v);
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(_vm.form, 'privacy', $$a.concat([$$v]));
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.form,
                                                  'privacy',
                                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1)),
                                                );
                                            }
                                          } else {
                                            _vm.$set(_vm.form, 'privacy', $$c);
                                          }
                                        },
                                        function ($event) {
                                          _vm.msg.privacy = '';
                                        },
                                      ],
                                    },
                                  }),
                                  _vm._m(7),
                                ],
                              ),
                              _c('div', [
                                _vm.msg.privacy.length
                                  ? _c('span', { staticClass: 'su-error-field-text' }, [
                                      _vm._v(_vm._s(_vm.msg.privacy)),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._m(8),
                            ]),
                          ]),
                          _c('div', { staticClass: 'col-md-6 col-12' }, [
                            _c('div', { staticClass: 'form-group' }, [
                              _c(
                                'button',
                                {
                                  staticClass: 'su-button',
                                  attrs: {
                                    disabled: _vm.loadingFormRequest,
                                    name: 'submit',
                                    type: 'submit',
                                  },
                                },
                                [_vm._v(' Send request now ')],
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                    ),
                  ]),
                ]),
              ]),
            ],
          ),
          _c(
            'div',
            {
              staticClass: 'su-section-eight container',
              attrs: { id: 'work-with-us' },
              on: {
                mouseover: function ($event) {
                  return _vm.$refs.mainNav.setFocus(6);
                },
                mouseleave: function ($event) {
                  return _vm.$refs.mainNav.setNotFocus(6);
                },
              },
            },
            [_vm._m(9)],
          ),
          _c('alert-row', { ref: 'alertMsg' }),
          _c('footer-row'),
          _c('loading-screen', { ref: 'loadingScreen' }),
        ],
        1,
      ),
    ],
    1,
  );
};
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c(
      'div',
      { staticClass: 'tooltip--left sound', attrs: { 'data-tooltip': 'Turn On/Off Sound' } },
      [
        _c('div', { staticClass: 'sound--icon fa fa-volume-off' }),
        _c('div', { staticClass: 'sound--wave sound--wave_one' }),
        _c('div', { staticClass: 'sound--wave sound--wave_two' }),
        _c('div', { staticClass: 'sound--wave sound--wave_three' }),
      ],
    );
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'su-section-two container' }, [
      _c('div', { staticClass: 'row' }, [
        _c('div', { staticClass: 'col-1 void-column' }),
        _c('div', { staticClass: 'col-12 col-md-11' }, [
          _c('div', { staticClass: 'row' }, [
            _c('div', { staticClass: 'col-12' }, [
              _c('h1', [
                _vm._v(
                  ' SHOWUP designs and produces entertainment, provides creative services and supplies talent for clients around the globe. ',
                ),
              ]),
            ]),
            _c('div', { staticClass: 'col-12 mb-5' }, [
              _c('h3', [
                _vm._v(' We bring a world of expertise, experience and'),
                _c('br'),
                _vm._v(' innovation to every stage. '),
              ]),
              _c('h3', [
                _vm._v(" Entertainment is more than our business, it's our"),
                _c('br'),
                _vm._v(' calling. We are inspired every day by the'),
                _c('br'),
                _vm._v(' opportunity to create moments of magic that will'),
                _c('br'),
                _vm._v(' stay with audiences long after the show is over. '),
              ]),
            ]),
            _c('div', { staticClass: 'col-12' }, [
              _c('a', { staticClass: 'su-link', attrs: { href: '/about' } }, [
                _c('span', { staticClass: 'addText' }, [
                  _vm._v('Where did we'),
                  _c('br'),
                  _vm._v('show up from?'),
                ]),
                _c('img', { staticClass: 'icon', attrs: { src: '/assets/img/about_us_cta.svg' } }),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]);
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('h3', [
      _vm._v(' and tested across five'),
      _c('br'),
      _vm._v(' continents, giving us a profound'),
      _c('br'),
      _vm._v(' understanding of what audiences'),
      _c('br'),
      _vm._v(' want and what clients need. '),
    ]);
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c(
      'div',
      { staticClass: 'tooltip--left sound', attrs: { 'data-tooltip': 'Turn On/Off Sound' } },
      [
        _c('div', { staticClass: 'sound--icon fa fa-volume-off' }),
        _c('div', { staticClass: 'sound--wave sound--wave_one' }),
        _c('div', { staticClass: 'sound--wave sound--wave_two' }),
        _c('div', { staticClass: 'sound--wave sound--wave_three' }),
      ],
    );
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'col-12 mt-md-5' }, [
      _c('h1', [_vm._v('We offer a full range of entertainment services on a global basis.')]),
    ]);
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'row' }, [
      _c('div', { staticClass: 'col-1 void-column' }),
      _c('a', { staticClass: 'wide-card col-12 col-md-11', attrs: { href: '/shows' } }, [
        _c('div', { staticClass: 'row' }, [
          _c('div', { staticClass: 'col-12 main-info' }, [
            _c('h1', [_vm._v('300')]),
            _c('span', [_vm._v('shows')]),
          ]),
          _c('div', { staticClass: 'col-6 secondary-info' }, [
            _c('h2', [_vm._v('900')]),
            _c('span', [_vm._v('Live Experiences')]),
          ]),
          _c('div', { staticClass: 'col-6 secondary-info' }, [
            _c('h2', [_vm._v('60')]),
            _c('span', [_vm._v(' performers and'), _c('br'), _vm._v(' technicians ')]),
          ]),
        ]),
        _c('div', { staticClass: 'row hover-info' }, [
          _c('div', { staticClass: 'col-12' }, [
            _c('h1', [_vm._v(' Take a look at'), _c('br'), _vm._v(' our shows ')]),
          ]),
        ]),
      ]),
    ]);
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'col-lg-4 col-12' }, [
      _c('h1', [_vm._v('Ask us anything.')]),
      _c('p', [
        _vm._v(
          " Whatever or whoever you're looking for in the entertainment world, get in touch. ",
        ),
      ]),
    ]);
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('label', { staticClass: 'custom-control-label', attrs: { for: 'terms' } }, [
      _vm._v(' Agree to the '),
      _c('a', { attrs: { href: '/privacy-policy' } }, [_vm._v('Privacy Policy')]),
      _vm._v('* '),
    ]);
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'required_fields_label' }, [
      _c('label', [_vm._v('*Required fields')]),
    ]);
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'row' }, [
      _c('div', { staticClass: 'col-1 void-column' }),
      _c('div', { staticClass: 'col-12 col-md-11' }, [
        _c('div', { staticClass: 'row mb-5' }, [
          _c('div', { staticClass: 'col-12' }, [
            _c('h1', [_vm._v('Join a world'), _c('br'), _vm._v('class team')]),
            _c('h3', [
              _vm._v(' Whether you shine on stage or behind the scenes,'),
              _c('br'),
              _vm._v(" we'd love to hear from you. "),
            ]),
          ]),
        ]),
        _c('div', { staticClass: 'row mb-3 justify-content-center' }, [
          _c('div', { staticClass: 'col-md-6 col-12 mb-3 pr-md-1' }, [
            _c(
              'a',
              { staticClass: 'medium-card left', attrs: { href: '/tech', id: 'tech-card' } },
              [
                _c('h3', [_vm._v('TECHNICIAN')]),
                _c('button', { staticClass: 'cta-work' }, [_vm._v('join us')]),
              ],
            ),
          ]),
          _c('div', { staticClass: 'col-md-6 col-12 mb-3 pl-md-1' }, [
            _c(
              'a',
              {
                staticClass: 'medium-card right',
                attrs: { href: '/performers', id: 'performers-card' },
              },
              [
                _c('h3', [_vm._v('PERFORMERS (VOCALISTS & DANCERS)')]),
                _c('button', { staticClass: 'cta-work' }, [_vm._v('join us')]),
              ],
            ),
          ]),
        ]),
        _c('div', { staticClass: 'row mb-3 justify-content-center' }, [
          _c('div', { staticClass: 'col-md-6 col-12 mb-3 pr-md-1' }, [
            _c(
              'a',
              {
                staticClass: 'medium-card left',
                attrs: { href: '/musicians', id: 'musicians-card' },
              },
              [
                _c('h3', [_vm._v('MUSICIANS')]),
                _c('button', { staticClass: 'cta-work' }, [_vm._v('join us')]),
              ],
            ),
          ]),
          _c('div', { staticClass: 'col-md-6 col-12 mb-3 pl-md-1' }, [
            _c(
              'a',
              {
                staticClass: 'medium-card right',
                attrs: { href: '/speciality-artists', id: 'speciality-artists-card' },
              },
              [
                _c('h3', [_vm._v('SPECIALITY ARTISTS')]),
                _c('button', { staticClass: 'cta-work' }, [_vm._v('join us')]),
              ],
            ),
          ]),
        ]),
        _c('div', { staticClass: 'row mb-3 justify-content-center' }, [
          _c('div', { staticClass: 'col-md-6 col-12 mb-3' }, [
            _c(
              'a',
              {
                staticClass: 'medium-card left',
                attrs: { href: '/salsa-couple', id: 'salsa-couple-card' },
              },
              [
                _c('h3', [_vm._v('SALSA COUPLE')]),
                _c('button', { staticClass: 'cta-work' }, [_vm._v('join us')]),
              ],
            ),
          ]),
        ]),
      ]),
    ]);
  },
];

export default Vue.extend({
  render,
  staticRenderFns,
  data() {
    return {
      display: 'lg' as string,
      mute: true,
      mute2: true,
      marquee1Pause: false,
      marquee2Pause: false,
      collapseButtonKnowhowStatus: 0,
      collapseButtonEntertainmentStatus: 0,
      toggleButtonText: ['Read more', 'Read less'],
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: 0.5,
      },
      loadingFormRequest: false,
      form: {
        name: '',
        email: '',
        message: '',
        privacy: [],
      },
      msg: {
        name: '',
        email: '',
        message: '',
        privacy: '',
      },
    };
  },
  mounted() {
    this.updateDisplay();
    window.addEventListener('resize', this.updateDisplay);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDisplay);
  },
  methods: {
    updateDisplay() {
      const w = window.innerWidth;
      if (w < 576) this.display = 'xs';
      else if (w < 768) this.display = 'sm';
      else if (w < 992) this.display = 'md';
      else this.display = 'lg';
    },
    muteToggle() {
      const player = (this.$refs.player as any);
      if (player) {
        this.mute = !this.mute;
        player.mute(this.mute);
      }
    },
    muteToggle2() {
      const player2 = (this.$refs.player2 as any);
      if (player2) {
        this.mute2 = !this.mute2;
        player2.mute(this.mute2);
      }
    },
    onReady() {
      const player = (this.$refs.player as any);
      if (player) player.play();
    },
    onWaypoint1({ going }: { going: string }) {
      if (going === 'in') {
        const loadingScreen = (this.$refs.loadingScreen as any);
        if (loadingScreen) loadingScreen.hide();
      }
    },
    onWaypoint2() {
      // section 2 waypoint
    },
    lockMarquee1(lock: boolean) {
      this.marquee1Pause = lock;
    },
    lockMarquee2(lock: boolean) {
      this.marquee2Pause = lock;
    },
    async submitEntry() {
      this.msg = { name: '', email: '', message: '', privacy: '' };
      let valid = true;
      if (!this.form.name) { this.msg.name = 'Name is required'; valid = false; }
      if (!this.form.email) { this.msg.email = 'Email is required'; valid = false; }
      if (!this.form.message) { this.msg.message = 'Message is required'; valid = false; }
      if (!this.form.privacy.length) { this.msg.privacy = 'You must accept the privacy policy'; valid = false; }
      if (!valid) return;

      this.loadingFormRequest = true;
      try {
        const axios = (await import('axios')).default;
        await axios.post('/php/contact.php', this.form);
        const alert = (this.$refs.alertMsg as any);
        if (alert) alert.showAlert('Message sent successfully!');
        this.form = { name: '', email: '', message: '', privacy: [] };
      } catch {
        const alert = (this.$refs.alertMsg as any);
        if (alert) alert.showAlert('An error occurred. Please try again.');
      } finally {
        this.loadingFormRequest = false;
      }
    },
  },
});
